import { useState } from "react";

const navLinks = [
  { label: "滚动短讯", href: "#live" },
  { label: "话题索引", href: "#index" },
  { label: "大图卡片流", href: "#flow" },
  { label: "发酵时间轴", href: "#timeline" },
  { label: "评论区", href: "#opinion" },
  { label: "话题合集", href: "#collections" },
];

export default function TopBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [reminded, setReminded] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-300/70 bg-background-100/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-3 px-4 md:px-6">
        <h1 className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            蝌
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold tracking-wide text-foreground-950">
              蝌蚪黑料
            </span>
            <span className="mt-1 font-label text-[10px] tracking-[0.2em] text-foreground-500">
              持续围观 · 舆论发酵追踪
            </span>
          </span>
        </h1>

        <nav className="ml-6 hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-200 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-2 md:flex">
          <div className="flex h-9 w-52 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 lg:w-60">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-sm"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索话题或关键词"
              className="w-full bg-transparent font-label text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            onClick={() => setReminded((prev) => !prev)}
            className={`flex h-9 items-center gap-1.5 whitespace-nowrap rounded-md px-3 font-label text-sm transition-colors ${
              reminded
                ? "bg-secondary-100 text-secondary-900"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={reminded ? "ri-notification-off-line text-sm" : "ri-notification-3-line text-sm"}></i>
            </span>
            {reminded ? "已开启提醒" : "开启围观提醒"}
          </button>
        </div>

        <button
          type="button"
          aria-label="展开导航菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
        </button>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-300/70 bg-background-100 px-4 pb-4 pt-3 lg:hidden">
          <div className="flex h-9 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-sm"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索话题或关键词"
              className="w-full bg-transparent font-label text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md bg-background-200 px-3 py-2 font-label text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            onClick={() => setReminded((prev) => !prev)}
            className="mt-3 flex h-9 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 font-label text-sm text-background-50"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={reminded ? "ri-notification-off-line text-sm" : "ri-notification-3-line text-sm"}></i>
            </span>
            {reminded ? "已开启提醒" : "开启围观提醒"}
          </button>
        </div>
      ) : null}

      {keyword.trim() ? (
        <div className="border-t border-background-300/70 bg-accent-100 px-4 py-2 font-label text-xs text-accent-900 md:px-6">
          正在话题库中检索“{keyword.trim()}”，共匹配 12 个相关性较高的话题与 286 条网友评论。
        </div>
      ) : null}
    </header>
  );
}